<template>
  <div>
    <BaseTitle :title="`${$t('content.use_template') + ' ' + templateName}`" />
    <v-row>
      <v-col cols="12" md="12">
        <form @submit.prevent="submit">
          <v-card class="mb-8">
            <div class="pa-6">
              <form-group :name="$t('content.questionnaire_name')" :validator="$v.form.quitionnaireName">
                <template slot-scope="{ attrs }">
                  <v-text-field
                    v-model="form.quitionnaireName"
                    v-bind="attrs"
                    :label="$t('content.questionnaire_name')"
                    @input="$v.form.quitionnaireName.$touch()"
                    @blur="$v.form.quitionnaireName.$touch()"
                  />
                </template>
              </form-group>
            </div>
          </v-card>
          <v-card class="mb-8">
            <div class="pa-6">
              <v-row>
                <v-col md="6">
                  <form-group :name="$t('content.list_class')" :validator="$v.form.classroomId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.classroomId"
                        v-bind="attrs"
                        :items="listClass"
                        item-text="name"
                        item-value="classroomId"
                        :label="$t('content.list_class')"
                        @change="getCourse(form.classroomId)"
                        @input="$v.form.classroomId.$touch()"
                        @blur="$v.form.classroomId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <form-group :label="$t('content.list_course')" :validator="$v.form.courseId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.courseId"
                        v-bind="attrs"
                        :items="listCourse"
                        item-text="name"
                        item-value="courseId"
                        :label="$t('content.list_course')"
                        @change="getTeacherAndStudent(form.classroomId, form.courseId)"
                        @input="$v.form.courseId.$touch()"
                        @blur="$v.form.courseId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
              </v-row>
              <v-row>
                <v-col md="6">
                  <form-group :label="$t('content.list_teacher')" :validator="$v.form.teacherId">
                    <template slot-scope="{ attrs }">
                      <v-select
                        v-model="form.teacherId"
                        v-bind="attrs"
                        :items="listTeacher"
                        item-text="fullName"
                        item-value="teacherId"
                        :label="$t('content.list_teacher')"
                        @input="$v.form.teacherId.$touch()"
                        @blur="$v.form.teacherId.$touch()"
                      />
                    </template>
                  </form-group>
                </v-col>
                <v-col md="6">
                  <v-row>
                    <v-col md="6">
                      <form-group :name="$t('form.date')" :validator="$v.form.dueDate" no-gutter>
                        <template slot-scope="{ attrs }">
                          <v-menu
                            ref="pickerDate"
                            v-model="pickerDate"
                            :close-on-content-click="false"
                            :return-value.sync="pickerDate"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template #activator="{ on, attrs:attrActivator }">
                              <v-text-field
                                v-model="form.dueDate"
                                :label="$t('form.date')"
                                readonly
                                v-bind="{ ...attrActivator, ...attrs }"
                                v-on="on"
                              >
                                <template #append>
                                  <svg-icon icon="calendar" class="primary--text mr-3" />
                                </template>
                              </v-text-field>
                            </template>
                            <v-date-picker v-model="form.dueDate" :locale="$i18n.locale">
                              <v-spacer />
                              <v-btn text color="primary" @click="pickerDate = false">{{ $t('cancel') }}</v-btn>
                              <v-btn text color="primary" @click="$refs.pickerDate.save(form.dueDate)">{{ $t('ok') }}</v-btn>
                            </v-date-picker>
                          </v-menu>
                        </template>
                      </form-group>
                    </v-col>
                    <v-col md="6">
                      <form-group :name="$t('form.time')" :validator="$v.form.dueTime" no-gutter>
                        <template slot-scope="{ attrs }">
                          <v-menu
                            ref="pickerTime"
                            v-model="pickerTime"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            :return-value.sync="pickerTime"
                            transition="scale-transition"
                            offset-y
                            max-width="290px"
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on, attrs: attrActivator }">
                              <v-text-field
                                v-model="form.dueTime"
                                :label="$t('form.time')"
                                readonly
                                v-bind="{ ...attrActivator, ...attrs }"
                                v-on="on"
                              >
                                <template #append>
                                  <svg-icon icon="clock" class="primary--text mr-3" />
                                </template>
                              </v-text-field>
                            </template>

                            <v-time-picker v-model="form.dueTime" :locale="$i18n.locale" @click:minute="$refs.pickerTime.save(form.dueTime)" />
                          </v-menu>
                        </template>
                      </form-group>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
              <div class="d-flex justify-space-between">
                <div class="app-section-title mb-6">{{ $t('content.list_student') }}</div>
                <div class="app-section-title mb-6" style="color:#00bf63;">
                  {{ listStudent.length ? listStudent.length : 0 }} {{ $t('content.student') }}
                </div>
              </div>
              <v-data-table :headers="tableHeaderStudent" :loading="loading" :items="listStudent" hide-default-footer class="table-custom">
                <template #no-data> <NoData /></template>
              </v-data-table>
            </div>
          </v-card>
          <v-card class="mb-8">
            <div class="pa-6">
              <div class="app-section-title mb-6">{{ $t('content.list_categories') }}</div>
              <v-data-table :headers="tableHeader" :loading="loading" :items="listCategory" hide-default-footer class="table-custom">
                <template #no-data><NoData /></template>
              </v-data-table>
            </div>
          </v-card>

          <div class="d-flex justify-end align-center mt-8">
            <v-btn color="primary" class="btn-primary-custom mr-3" outlined @click="back">{{ $t('cancel') }}</v-btn>
            <v-btn color="primary" class="btn-primary-custom" @click="submit" :loading="loading">
              {{ $t('submit') }}
            </v-btn>
          </div>
        </form>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import BaseTitle from '@/components/base/Title';
import { maxLength, required } from 'vuelidate/lib/validators';
import { mapGetters } from 'vuex';
import NoData from '@/components/table/NoData';
export default {
  name: 'UseTemplateTeacher',
  components: {
    BaseTitle,
    NoData
  },
  props: {
    isClass: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: false
    },
    isStudent: {
      type: Boolean,
      default: false
    }
  },
  validations() {
    return {
      form: {
        quitionnaireName: { required, maxLength: maxLength(30) },
        classroomId: { required },
        courseId: { required },
        teacherId: { required },
        dueDate: { required },
        dueTime: { required }
      }
    };
  },
  computed: {
    ...mapGetters({
      classLevel: 'QuizTeacher/classLevel',
      tokenBearer: 'Auth/token',
      user: 'Auth/user'
    }),
    tableHeaderStudent() {
      return [
        { text: this.$t('content.student_name'), value: 'fullName' },
        { text: 'NIS', value: 'identityNumber' }
      ];
    },
    tableHeader() {
      return [
        { text: this.$t('table.name'), value: 'categoryName' },
        { text: this.$t('content.min_value'), value: 'valueMin' },
        { text: this.$t('content.max_value'), value: 'valueMax' }
      ];
    }
  },
  data: () => ({
    form: {
      quitionnaireName: '',
      classroomId: '',
      courseId: '',
      teacherId: '',
      dueDate: '',
      dueTime: '',
      analyticalTemplateId: ''
    },
    templateName: '',
    listCategory: [],
    listStudent: [],
    listClass: [],
    listCourse: [],
    listTeacher: [],
    loading: false,
    pickerDate: false,
    pickerTime: false,
    edit: false
  }),
  methods: {
    getData() {
      this.$store.dispatch('Analytical/getListTemplateById', this.$route.params.idTemplate).then(ras => {
        this.form.analyticalTemplateId = parseInt(this.$route.params.idTemplate);
        this.templateName = ras.templateName;
      });
    },
    getListCategory() {
      this.loading = true;
      this.$store
        .dispatch(`Analytical/getListCategoryTemplateQuiz`, this.$route.params.idTemplate ? this.$route.params.idTemplate : '')
        .then(data => (this.listCategory = data))
        .finally(() => (this.loading = false));
    },
    getClass() {
      this.loadingLoad = true;
      this.$store
        .dispatch('SchoolClass/fetchList', {
          search: ''
        })
        .then(data => (this.listClass = data))
        .finally(() => (this.loadingLoad = false));
    },
    getCourse(id) {
      this.listStudent = [];
      this.form.courseId = '';

      const payload = { id: id, classid: id };
      this.loadingLoad = true;
      this.$store
        .dispatch('CourseList/fetchList', payload)
        .then(data => (this.listCourse = data))
        .finally(() => (this.loadingLoad = false));
    },
    getTeacherAndStudent(classroomId, courseId) {
      this.loadingLoad = true;
      this.$store
        .dispatch('Analytical/getQuizListTeacher', { classroomId, courseId })
        .then(data => (this.listTeacher = data))
        .finally(() => {
          this.loadingLoad = true;
          this.$store
            .dispatch('Analytical/getQuizListStudent', { classroomId, courseId })
            .then(data => (this.listStudent = data))
            .finally(() => {
              this.loadingLoad = false;
            });
        });
    },
    submit() {
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return false;
      }

      this.loading = true;

      this.$store
        .dispatch(`Analytical/createQuiz`, { ...this.form })
        .then(() =>
          this.$router.push({
            name: 'UseTemplateTeacherSuccess'
          })
        )
        .finally(() => (this.loading = false));
    },
    back() {
      this.$router.push({ name: 'AnalyticTeacherListID', params: { idSidebar: 2 } });
    }
  },
  created() {
    this.getData();
    this.getListCategory();
    this.getClass();
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

body {
  height: 100%;
}
.header-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 13px;
  line-height: 16px;
  width: 133px;
  text-align: left;
}

.body-content {
  color: #6d6d6d;
  font-family: Montserrat;
  font-size: 12px;
  line-height: 14px;
  text-align: left;
}
</style>
